module.exports = __webpack_public_path__ + "static/media/step-backward.a8d56457.svg";